import {SafeAreaView, StyleSheet, Text, View} from 'react-native';
import React, {useEffect} from 'react';
import {observer} from 'mobx-react';
import {AnalyticsScreenProps} from 'navigations/AnalyticsFlow';
import {useTheme} from 'contexts/ThemeContext';
import {useAnalyticsStore} from 'contexts/StoreContext';
import StudentList from 'components/molecules/studentsList';
import styleSheet from './styles';

const AttendeesScreen = observer((props: AnalyticsScreenProps) => {
  const styles = styleSheet(useTheme());
  const analyticsStore = useAnalyticsStore();
  const {allAttendees} = analyticsStore;

  const {id} = props.route.params;

  useEffect(() => {
    const prefetchData = async () => {
      analyticsStore.getAttendees(id);
    };

    prefetchData();
  }, []);

  return (
    <SafeAreaView style={styles.safeArea}>
      <View style={styles.containerStyle}>
        <StudentList data={allAttendees} disabled />
      </View>
    </SafeAreaView>
  );
});

export default AttendeesScreen;
